import { useMemo } from "react";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import {
  EMAIL_ACTION_SIDEBAR_VIEW_MAP,
  type EmailTypography,
} from "../Themes/Tokens/Text/TextStylesConstants";

const BLOCK_TYPE_TO_TYPOGRAPHY_LEVEL: Record<string, EmailTypography> = {
  h1: EMAIL_ACTION_SIDEBAR_VIEW_MAP.emailH1TextStyles,
  h2: EMAIL_ACTION_SIDEBAR_VIEW_MAP.emailH2TextStyles,
  h3: EMAIL_ACTION_SIDEBAR_VIEW_MAP.emailH3TextStyles,
  h4: EMAIL_ACTION_SIDEBAR_VIEW_MAP.emailH4TextStyles,
  h5: EMAIL_ACTION_SIDEBAR_VIEW_MAP.emailH5TextStyles,
  h6: EMAIL_ACTION_SIDEBAR_VIEW_MAP.emailH6TextStyles,
  paragraph: EMAIL_ACTION_SIDEBAR_VIEW_MAP.emailP1TextStyles,
  text: EMAIL_ACTION_SIDEBAR_VIEW_MAP.emailP1TextStyles,
  p1: EMAIL_ACTION_SIDEBAR_VIEW_MAP.emailP1TextStyles,
  p2: EMAIL_ACTION_SIDEBAR_VIEW_MAP.emailP2TextStyles,
  p3: EMAIL_ACTION_SIDEBAR_VIEW_MAP.emailP3TextStyles,
};

const DEFAULT_TYPOGRAPHY_LEVEL =
  EMAIL_ACTION_SIDEBAR_VIEW_MAP.emailP1TextStyles;

/**
 * Hook to determine the typography level based on the selected block type.
 * Maps block types (h1-h6, p1-p3, paragraph, text) to email typography levels.
 */
export const useCurrentBlockTypography = (): string => {
  const selectedBlock = useBuilderStore(
    state => state.getSelectedBlock()?.block ?? null,
  );

  return useMemo(() => {
    if (!selectedBlock?.type) {
      return DEFAULT_TYPOGRAPHY_LEVEL;
    }

    return (
      BLOCK_TYPE_TO_TYPOGRAPHY_LEVEL[selectedBlock.type] ||
      DEFAULT_TYPOGRAPHY_LEVEL
    );
  }, [selectedBlock?.type]);
};
